import '@styles/webdesktop/stylesheets/sideToggleOption.scss';
import { OperationType } from '@shared/utils/Trading/OperationType';
import React from 'react';
import { Typography } from '../Typography/Typography';
import { TypographyLevel } from '../Typography/TypographyLevel';
export const SideToggleOption = ({ groupId, value, checked, text, onChange, disabled = false }) => {
    const sufix = value === OperationType.Buy ? 'buy' : 'sell';
    const disabledClass = disabled ? ' disabled' : '';
    const checkedClass = checked ? ' side-toggle-active' : '';
    return (React.createElement("label", { className: `side-toggle-option side-toggle-${sufix}${checkedClass}${disabledClass}` },
        React.createElement("input", { type: "radio", name: groupId, checked: checked, onChange: () => onChange(value), disabled: disabled }),
        React.createElement(Typography, { level: TypographyLevel.BodyMd }, text)));
};
